import React, { useMemo } from 'react'
import TextInput from './../../../../../../common/components/Form/TextInput/TextInput.jsx'
import openCenteredPopup from './../../../../../../common/utils/openCenteredPopup.js'

import img1 from '../../../../../../images/png/share/1.png'
import img2 from '../../../../../../images/png/share/2.png'

import { SHARE_MODAL_TABS, SOCIAL_BLOCKS } from '../utils/constants.js'

import './ShareProjectMainTab.scss'
import copy from 'copy-to-clipboard'
import Toast from '../../../../../../common/components/Toast/Toast'

const ShareProjectMainTab = ({ projectUrl, setTab, t }) => {
    const renderedSocialLinks = useMemo(
        () =>
            Object.values(SOCIAL_BLOCKS).map(block => (
                <div
                    className="share-project-tab__social-link"
                    key={block.url}
                    onClick={() =>
                        openCenteredPopup({
                            url: block.url.replace('%URL%', projectUrl),
                            title: `Share ${block.alt}`,
                            height: 500,
                            width: 600,
                        })
                    }
                >
                    <img src={block.icon} alt={block.alt} />
                    <span>{block.text}</span>
                </div>
            )),
        [projectUrl],
    )

    const handleCopyProjectUrl = (value) => {
        copy(value)
        Toast('success', {
            title: t('_components._modal._share_project.link_copied'),
            time: 2000,
        })
    }

    return (
        <div className="share-project-tab">
            <div className="share-project-tab__block">
                <p className="share-project-tab__block-title">{t('_components._modal._share_project.title_1')}</p>
                <div className="share-project-tab__block-content">
                    <div className="share-project-tab__url-zone">
                        <div className="share-project-tab__url-zone-input">
                            <TextInput value={projectUrl} data-test="published-project-url" isReadOnly />
                        </div>
                        <button
                            className="button share-project-tab__url-zone-button"
                            data-variant="primary"
                            data-size="lg"
                            onClick={() => handleCopyProjectUrl(projectUrl)}
                        >
                            {t('_common.copy_link')}
                        </button>
                    </div>
                </div>
            </div>
            <div className="share-project-tab__block">
                <p className="share-project-tab__block-title">{t('_components._modal._share_project.title_2')}</p>
                <div className="share-project-tab__block-content">
                    <ul className="share-project-tab__cards">
                        <li
                            className="share-project-tab__cards-item clickable"
                            onClick={() => setTab(SHARE_MODAL_TABS.embedCode)}
                        >
                            <p className="share-project-tab__cards-item-title">
                                {t('Embed in your Website or LMS')}
                            </p>
                            <div className="share-project-tab__cards-item-box">
                                <img src={img1} alt="" />
                            </div>
                        </li>
                        <li className="share-project-tab__cards-item">
                            <p className="share-project-tab__cards-item-title">
                                {t('_components._modal._share_project.text_3')}
                            </p>
                            <div className="share-project-tab__cards-item-box box-many">{renderedSocialLinks}</div>
                        </li>
                        <li className="share-project-tab__cards-item disabled">
                            <p className="share-project-tab__cards-item-title">
                                {t('_components._modal._share_project.text_2')}
                            </p>
                            <div className="share-project-tab__cards-item-box">
                                <img src={img2} alt="" />
                            </div>
                            <div className="fake-btn">{t('_common.coming_soon')}</div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default ShareProjectMainTab
